import { toast } from "../apis/request";

const TextNoty = (successfulText, type = "error") => {
  return toast({ text: successfulText, type });
};

export default TextNoty;
